import React from 'react'
import './ShopPage.scss';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import carImage from '../imgs/voucher-category-car.svg'
import bikeImage from '../imgs/voucher-category-bike.svg'
import voucherImage from '../imgs/voucher-category-voucher.svg'

import { Swipeable } from 'react-touch';

import { push } from 'connected-react-router'

import OrderCalendarPage from './OrderCalendarPage';
import VoucherPage from './VoucherPage';

import { loadShopData } from '../actions'
import { objectToArray } from '../helper'
import { Link } from 'react-router-dom'
import OfferSlider from '../components/OfferSlider'

import postNavButtonImage from '../scss/imgs/posts-nav-buttton.svg'

const renderVoucherCategories = (props, content) => {
    loadShopData()

    return (
        <article className={"shop-page page"}>
            
            {content}
        </article>
    );
}

class ShopCategories extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            index: 0
        }
    }

    right() {
        this.setState({index: Math.min(this.state.index + 1, 2)})
    }

    left() {
        this.setState({index: Math.max(this.state.index - 1, 0)})
    }

    render() {
        let translateX = 0;
        if (this.state.index > 0) {
            translateX = window.innerWidth * -this.state.index;
        }

        return <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <h1 className="text-center shop-title">Gutschein wählen</h1>
                    <Swipeable onSwipeLeft={() => this.right()} onSwipeRight={() => this.left()}>
                        <div ref="container" className="shop-category-list-container">
                            {this.state.index > 0 && (
                            <button className="shop-category-list-left" onClick={() => this.left()}>
                                <img src={postNavButtonImage} />
                            </button>
                            )}
                            {this.state.index < 2 && (
                            <button className="shop-category-list-right" onClick={() => this.right()}>
                                <img src={postNavButtonImage} />
                            </button>
                            )}
                            <div ref="list" className="shop-category-list" style={{transform: "translateX("+translateX+"px)"}}>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={carImage} alt="PKW-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        GUTSCHEIN
                                    </div>
                                    <div className="shop-category-title">
                                        PKW-TRAINING
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/gutscheine/pkw" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={bikeImage} alt="Motorrad-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        GUTSCHEIN
                                    </div>
                                    <div className="shop-category-title">
                                        MOTORRAD-TRAINING
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/gutscheine/motorrad" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={voucherImage} alt="Wertgutschein" />
                                    </div>
                                    <div className="shop-category-type">
                                        GUTSCHEIN
                                    </div>
                                    <div className="shop-category-title">
                                        FREIER BETRAG
                                    </div>
                                    <div className="shop-category-button">
                                        <Link key='amount' to="/shop/gutschein" className="btn">Jetzt buchen</Link>                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Swipeable>
                </div>
            </div>
        </section>
    }
}


class VoucherCategories extends React.Component { 
    render() {
        return renderVoucherCategories(this.props, <ShopCategories />)
    }
}

const mapStateToProps = state => {
  return {
    
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default withRouter(connect(
    mapStateToProps, 
    mapDispatchToProps
)(VoucherCategories))


// WEBPACK FOOTER //
// ./src/pages/VoucherCategories.jsx